import {Account} from "../accounts/types.ts";
import {Code, Stack, Text} from '@mantine/core';


export const DisplayUserState = (props: { accounts: Account[], enabled: boolean }) => {

    if (!props.enabled) {
        return null;
    }
    
    return (
        <Stack gap="xs">
            <Text fw={500}>User Props:</Text>
            <Code block>
                {JSON.stringify(props, null, 2)}
            </Code>
        </Stack>
    );

}


